import React from 'react';

import { FileInput, FormGroup } from '@blueprintjs/core';

import { FileNameArea } from './styles';

interface UploaderProps {
  file: null | File;
  onVideoSelected: (video: any) => void;
}

const Uploader = ({ file, onVideoSelected }: UploaderProps) => {
  return (
    <FormGroup label="Envio de vídeo">
      <FileInput
        fill
        text="Choose file..."
        onInputChange={(e) => onVideoSelected(e)}
      />
      {!!file && (
        <FileNameArea>
          <b>File:</b> {file.name}
        </FileNameArea>
      )}
    </FormGroup>
  );
};

export default Uploader;
